import { PointItem } from "../types/PointItem";

const STORAGE_KEY = "pointItems";

function readAll(): PointItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as PointItem[];
  } catch {
    return [];
  }
}

function writeAll(items: PointItem[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function ensureDefaultPointItems() {
  const existing = readAll();
  if (existing.length > 0) return;
  const seed: Omit<PointItem, "id">[] = [
    { title: "쿠폰 지급 (30포인트 차감)", score: -30, activationConditions: ["POINTS_GE_30"], popoverItems: ["배스킨라빈스", "빵꾸똥꾸"], active: true },
    { title: "과제 미제출, 휴대폰 미제출", score: -1, activationConditions: [], popoverItems: [], active: true },
    { title: "과제 완제출, 수업 태도 양호", score: 1, activationConditions: [], popoverItems: [], active: true },
    { title: "완제출의 분량이 많음", score: 2, activationConditions: [], popoverItems: [], active: true },
    { title: "교재 완료", score: 4, activationConditions: [], popoverItems: [], active: true },
    { title: "KTC 경시에서 장려상 수상", score: 5, activationConditions: [], popoverItems: [], active: true },
    { title: "KTC 경시에서 동상 수상", score: 7, activationConditions: [], popoverItems: [], active: true },
    { title: "KTC 경시에서 은상 수상", score: 10, activationConditions: [], popoverItems: [], active: true },
    { title: "KTC 경시에서 금상 수상", score: 15, activationConditions: [], popoverItems: [], active: true },
    { title: "KTC 경시에서 대상 수상", score: 20, activationConditions: [], popoverItems: [], active: true },
  ];
  const withIds: PointItem[] = seed.map((s, idx) => ({ id: String(Date.now() + idx), ...s }));
  writeAll(withIds);
}

export async function listPointItems(): Promise<PointItem[]> {
  return readAll();
}

export async function getPointItem(id: string): Promise<PointItem | undefined> {
  return readAll().find((i) => i.id === id);
}

export async function upsertPointItem(item: PointItem): Promise<PointItem> {
  const items = readAll();
  const idx = items.findIndex((i) => i.id === item.id);
  if (idx >= 0) items[idx] = item; else items.push(item);
  writeAll(items);
  return item;
}

export async function createPointItem(partial: Omit<PointItem, "id">): Promise<PointItem> {
  const item: PointItem = { id: String(Date.now()), ...partial } as PointItem;
  const items = readAll();
  items.push(item);
  writeAll(items);
  return item;
}

export async function deletePointItem(id: string): Promise<void> {
  const items = readAll().filter((i) => i.id !== id);
  writeAll(items);
}
